var basicPath='detect'
export const verifyReport ={
    verifyList:basicPath+'/detect-info/list',
    doVerify:basicPath+'/detect-info/do-audit',
    list:basicPath + '/detect-info/list'
}
export const merchant ={
    addMerchant:basicPath+'/merchant-info/apply',
}